"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputGroup = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FieldLayout = require("./layout/FieldLayout");

var _FieldLabel = require("./microFields/FieldLabel");

var _FieldHelper = require("./microFields/FieldHelper");

var _FieldCounter = require("./microFields/FieldCounter");

var _FieldValidationMessage = require("./microFields/FieldValidationMessage");

var _InputInnerWrap = require("./InputInnerWrap");

var _SecondaryButton = require("./buttons/SecondaryButton");

var _fieldUtils = require("./microFields/fieldUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputGroupButton = function InputGroupButton(_ref) {
  var submitButton = _ref.submitButton,
      cashbotName = _ref.cashbotName;

  var _ref2 = submitButton || {},
      _ref2$btnText = _ref2.btnText,
      btnText = _ref2$btnText === void 0 ? null : _ref2$btnText,
      _ref2$onClick = _ref2.onClick,
      onClick = _ref2$onClick === void 0 ? null : _ref2$onClick;

  var buttonProps = {
    btnText: btnText,
    cashbotName: cashbotName,
    onClick: onClick,
    type: 'submit',
    isSmall: true
  };
  return _react.default.createElement(_SecondaryButton.SecondaryButton, buttonProps);
};

InputGroupButton.defaultProps = {
  submitButton: null
};
InputGroupButton.propTypes = {
  cashbotName: _propTypes.default.string.isRequired,
  submitButton: _propTypes.default.shape({
    btnText: _propTypes.default.string.isRequired,
    onClick: _propTypes.default.func.isRequired
  })
};

var InputGroup = function InputGroup(_ref3) {
  var fieldName = _ref3.fieldName,
      value = _ref3.value,
      atts = _ref3.atts,
      label = _ref3.label,
      helper = _ref3.helper,
      showHelper = _ref3.showHelper,
      cashbotName = _ref3.cashbotName,
      isActive = _ref3.isActive,
      isInvalid = _ref3.isInvalid,
      isTouched = _ref3.isTouched,
      errorMessage = _ref3.errorMessage,
      warningMessage = _ref3.warningMessage,
      isRequiredField = _ref3.isRequiredField,
      hasMaxLengthCounter = _ref3.hasMaxLengthCounter,
      counterAriaLabel = _ref3.counterAriaLabel,
      wrappedElement = _ref3.wrappedElement,
      showUntouchedErrors = _ref3.showUntouchedErrors,
      doFocus = _ref3.doFocus,
      submitButton = _ref3.submitButton;
  var showCounter = hasMaxLengthCounter && atts.maxLength ? (0, _fieldUtils.showMaxLengthCounter)(value, atts.maxLength) : false;
  var fieldIds = (0, _fieldUtils.getAllFieldElementIds)(fieldName);
  var validationProps = (0, _fieldUtils.getValidationProps)(value, isInvalid, isTouched, warningMessage, errorMessage, showCounter, showUntouchedErrors);
  var showInvalid = validationProps.isInvalid;
  var labelProps = {
    fieldName: fieldName,
    label: label,
    isInvalid: showInvalid
  };
  var counterProps = {
    id: fieldIds.counter.id,
    current: value.length || 0,
    maxLength: atts.maxLength,
    isInvalid: showInvalid,
    showCounter: showCounter,
    counterAriaLabel: counterAriaLabel
  };
  var helperProps = {
    id: fieldIds.helper.id,
    helper: helper,
    isHidden: !isActive && !showHelper
  };
  var validationMsgProps = {
    id: fieldIds.validation.id,
    fieldName: fieldName,
    validationProps: validationProps
  };
  var inputInnerProps = {
    fieldName: fieldName,
    atts: atts,
    label: label,
    helper: helper,
    isRequiredField: isRequiredField,
    isInvalid: showInvalid,
    validationProps: validationProps,
    wrappedElement: wrappedElement,
    doFocus: doFocus
  };
  var showButton = Boolean(submitButton);
  return _react.default.createElement(_FieldLayout.FieldWrapper, {
    fieldName: fieldName,
    cashbotName: cashbotName
  }, _react.default.createElement(_FieldLabel.FieldLabel, labelProps), showButton ? _react.default.createElement("div", {
    className: "input-with-button"
  }, _react.default.createElement(_InputInnerWrap.InputInnerWrap, inputInnerProps), _react.default.createElement(InputGroupButton, {
    cashbotName: cashbotName,
    submitButton: submitButton
  })) : _react.default.createElement(_InputInnerWrap.InputInnerWrap, inputInnerProps), hasMaxLengthCounter && _react.default.createElement(_FieldCounter.FieldCounterWarning, counterProps), _react.default.createElement(_FieldValidationMessage.FieldValidationMessage, validationMsgProps), helper && _react.default.createElement(_FieldHelper.FieldHelper, helperProps));
};

exports.InputGroup = InputGroup;
InputGroup.defaultProps = {
  doFocus: false,
  helper: '',
  showHelper: false,
  hasMaxLengthCounter: false,
  counterAriaLabel: null,
  isActive: false,
  isInvalid: false,
  isTouched: false,
  warningMessage: null,
  errorMessage: null,
  isRequiredField: true,
  showUntouchedErrors: false,
  wrappedElement: null,
  // optional element icon/image inside FieldDivWrapper for positioning
  submitButton: null
};
InputGroup.propTypes = {
  fieldName: _propTypes.default.string.isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  atts: _propTypes.default.shape({
    maxLength: _propTypes.default.number.isRequired,
    type: _propTypes.default.oneOf(['email', 'tel', 'text'])
  }).isRequired,
  helper: _propTypes.default.string,
  showHelper: _propTypes.default.bool,
  label: _propTypes.default.string.isRequired,
  cashbotName: _propTypes.default.string.isRequired,
  hasMaxLengthCounter: _propTypes.default.bool,
  counterAriaLabel: function counterAriaLabel(props, propName, componentName) {
    return props.hasMaxLengthCounter && (props[propName] === undefined || typeof props[propName] !== 'function') ? new Error("".concat(propName, " must be a function when hasMaxLengthCounter is true (component: ").concat(componentName, ")")) : undefined;
  },
  isActive: _propTypes.default.bool,
  isInvalid: _propTypes.default.bool,
  isTouched: _propTypes.default.bool,
  warningMessage: _propTypes.default.string,
  errorMessage: _propTypes.default.string,
  isRequiredField: _propTypes.default.bool,
  showUntouchedErrors: _propTypes.default.bool,
  wrappedElement: _propTypes.default.node,
  doFocus: _propTypes.default.bool,
  submitButton: _propTypes.default.shape({
    btnText: _propTypes.default.string.isRequired,
    onClick: _propTypes.default.func.isRequired
  })
};